import handleItemValueCalculation from './handleItemValueCalculation';

export default function handleItemHeightCalculation(data, amount) {
  if (data.length === 0) return null;

  const {
    chartMin,
    chartMax,
  } = handleItemValueCalculation(data);

  return (amount < 0 ? (amount / chartMin) : (amount / chartMax)) * 100;
}
